











































































































































import Vue, { PropType } from 'vue'

export interface PaginationCaption {
  total: number
  from: number
  to: number
}

type PageItem = {
  number: number
}

export default Vue.extend({
  name: 'XPagination',
  props: {
    length: {
      type: Number,
      required: true,
    },
    totalVisible: {
      type: Number,
      default: undefined,
    },
    value: {
      type: Number,
      default: 0,
    },
    showFirst: {
      type: Boolean,
      default: false,
    },
    showLast: {
      type: Boolean,
      default: false,
    },
    caption: {
      type: Object as PropType<PaginationCaption>,
      required: false,
    },
  },
  computed: {
    atLast() {
      return this.value === this.length
    },
    atFirst() {
      return this.value === 1
    },
    pages() {
      const visible = this.totalVisible || this.length
      const allPages = Array.from({ length: this.length }, (_, v) => v + 1)

      let showPages = []
      if (this.length - this.value < visible) {
        showPages = allPages.slice(allPages.length - visible)
      } else {
        showPages = allPages.slice(this.value - 1, this.value - 1 + visible)
      }

      return showPages.map((v) => {
        return {
          number: v,
        }
      })
    },
  },
  methods: {
    isSelected(page: PageItem) {
      return page.number === this.value ? 'selected' : ''
    },
    onSelected(page: PageItem) {
      this.$emit('input', page.number)
    },
    onNext() {
      if (this.value >= this.length) {
        return
      }
      this.$emit('input', this.value + 1)
    },
    onPrevious() {
      if (this.value <= 1) {
        return
      }
      this.$emit('input', this.value - 1)
    },
    onFirst() {
      this.$emit('input', 1)
    },
    onLast() {
      this.$emit('input', this.length)
    },
  },
})
